import Duck from 'extensible-duck';
import Immutable from 'immutable';

export default new Duck({
  namespace: 'public',
  store: 'slideshow',
  types: [],
  initialState: Immutable.fromJS({
    $$slideshows: [],
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      default:
        return $$state;
    }
  },
  selectors: {},
  creators: ({ types }) => ({}),
});
